import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { FormGroup } from 'react-bootstrap';
import { FormControl } from 'react-bootstrap';
import { ControlLabel } from 'react-bootstrap';
import { HelpBlock } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { Image } from 'react-bootstrap';

import Logo from '../statics/images/logo_default.png'
import Loader from 'react-loader-advanced';

import '../statics/css/login.css';

import { singIn } from '../dao-firebase/user-firebase';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      message: '',
      loader: false,
    }
  }

  componentWillMount() {

    this.verifyUser();
  }

  getValidationState() {
    const length = this.state.email.length;
    if (this.validateEmail(this.state.email)) {
      return 'success';
    }
    else if (length > 0) {
      return 'warning';
    }
    return null;
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  onInputChange(target) {

    console.log(target);

    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  closeMessage() {
    this.setState({ message: '' });
  }

  validateForm() {

    this.state.message = "";

    if (this.state.email == "" && this.state.password == "") {

      this.setState({
        message: "Preencha o email e a senha"
      })
      return false;
    } else if (this.state.email == "") {
      this.setState({
        message: "Preencha o email"
      })
      return false;
    } else if (this.state.password == "") {
      this.setState({
        message: "Preencha a senha"
      })
      return false;
    } else if (!this.validateEmail(this.state.email)) {
      this.setState({
        message: "Email incorreto"
      })
      return false;
    } else if (this.state.password.length < 6) {
      this.setState({
        message: "A senha deve ter no mínimo 4 caracteres"
      })
      return false;
    }

    return true;
  }

  onHandleSubmit(event) {
    event.preventDefault();

    this.setState({
      message: '',
      load: true,
    }, () => {

      if (this.validateForm()) {

        console.log("EMAIL: ", this.state.email)

        singIn(this.state.email, this.state.password, (response, success) => {

          if (success) {

            //Caso seja sucesso recebemos um objeto user da collections 'users'
            localStorage.setItem("USER", JSON.stringify(response))
            console.log("USUARIO INSERIDO NO LOCAL STORAGE: ")
            console.log(response)
            //Entrando na aplicação
            this.props.history.push('/');

            this.setState({
              message: '',
              load: false,
            });

          } else {

            let m = '';
            if (response.code == "auth/user-not-found") {
              m = "Usuário não cadastrado ou ainda não aceito pelo professor";
            } else if (response.code == "auth/wrong-password") {
              m = "Senha incorreta!";
            }

            this.setState({
              message: m,
              load: false,
            });
          }
        })



        //this.state.email = "";
        //this.state.password = "";
      } else {
        this.setState({

          load: false,
        });
      }
    });

  }

  goToRegister() {
    console.log("IR PARA REGISTRAR");
    this.props.history.push('/registrar');
  }

  verifyUser() {
    if (JSON.parse(localStorage.getItem("USER")) == undefined || JSON.parse(localStorage.getItem("USER")) == null) {

      this.props.history.push('/login')

    } else {

      switch (JSON.parse(localStorage.getItem("USER")).role) {

        case 'student':

          this.setState({
            user_role: 'student',
          })

          this.props.history.push('/aluno_detail')
          break;


        case 'professor':
          this.setState({
            user_role: 'professor',
          })

          this.props.history.push('/alunos')

          break;
      }

      console.log("USER LOGADO: " + localStorage.getItem("USER"));
    }

    this.setState({
      loaded: false,
    })
  }

  renderMessage(message) {
    return (
      <p>
        <strong>{message.substring(0, message.indexOf(" "))}</strong>
        {message.substring(message.indexOf(" "))}
      </p>
    )
  }

  render() {
    return (
      <div className="login-page">

        <Loader show={this.state.load} message={<div className="loader"></div>}
          backgroundStyle={{ backgroundColor: 'none' }}
          foregroundStyle={{ color: 'white', backgroundColor: 'rgb(255,255,255,0.7)' }}>

          <div className="form">
            <Image src={Logo} responsive />

            <form className="form-login" onSubmit={(event) => this.onHandleSubmit(event)}>
              {this.state.message != '' ?
                <Alert bsStyle="warning">
                  {this.renderMessage(this.state.message)}
                </Alert>
                : null}
              <FormGroup
                controlId="formBasicText"
                validationState={this.getValidationState()}>
                {/*<ControlLabel>Working example with validation</ControlLabel>*/}
                <FormControl
                  className="email-input"
                  name="email"
                  type="text"
                  value={this.state.email}
                  placeholder="Email"
                  onChange={(event) => this.onInputChange(event.target)}
                />
                <FormControl
                  className="password-input"
                  name="password"
                  type="password"
                  value={this.state.password}
                  placeholder="Senha"
                  onChange={(event) => this.onInputChange(event.target)}
                />
                <FormControl.Feedback />

              </FormGroup>

              <Button type="submit">Entrar</Button>
              <div className="form-register" onClick={() => this.goToRegister()}>
                <HelpBlock>Ainda não faz parte do time?</HelpBlock>
                <strong>Cadastre-se</strong>
              </div>
            </form>

          </div>
        </Loader>
      </div >
    );
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// src/components/login-form.js